import { Colors } from '@back-office/core';
import Avatar, { AvatarProps } from '@material-ui/core/Avatar';
import React from 'react';
import styled from 'styled-components';

export enum TransactionStatus {
  Authorized = 'authorized',
  AuthorizedVoided = 'authorized_voided',
  Cancelled = 'cancelled',
  Cleared = 'cleared',
  ClearedPendingRefund = 'cleared_pending_refund',
  ClearedRefunded = 'cleared_refunded',
  Confirming = 'confirming',
  DropOff = 'drop_off',
  Pending = 'pending',
  RefundRequestPending = 'refund_request_pending',
  Rejected = 'rejected',
  Captured = 'captured',
  Unmatched = 'unmatched',
  Processing = 'processing',
}

export enum TransactionSubStatus {
  cleared = 'cleared',
  pending = 'pending',
  void = 'cancelled',
}

interface GcpStatusProps extends AvatarProps {
  size?: number;
  status?: TransactionStatus;
}

function chooseStatusColor(status: TransactionStatus): keyof Colors {
  switch (status) {
    case TransactionStatus.Pending:
      return 'goldenrod';
    case TransactionStatus.ClearedPendingRefund:
      return 'goldenrod';
    case TransactionStatus.RefundRequestPending:
      return 'goldenrod';
    case TransactionStatus.Rejected:
      return 'redOrange';
    case TransactionStatus.Cancelled:
      return 'redOrange';
    case TransactionStatus.Confirming:
      return 'silver';
    case TransactionStatus.DropOff:
      return 'silver';
    case TransactionStatus.Processing:
      return 'goldenrod';
  }
  return 'eucalyptus';
}

const getSize = (size: number): string => {
  if (size) {
    return `${size}px`;
  }
  return '1rem';
};

export const GcpStatus = styled(({ size, status, ...rest }: GcpStatusProps) => (
  <Avatar {...rest}>&nbsp;</Avatar>
))<GcpStatusProps>`
  ${(props): string =>
    props?.status &&
    `background-color: ${
      props.theme.palette?.common[chooseStatusColor(props.status)]
    }`};
  height: ${(props) => getSize(props.size)}};
  width: ${(props) => getSize(props.size)}};
`;

export default GcpStatus;
